import { render } from "./WalksView.vue?vue&type=template&id=540dade8&scoped=true"
import script from "./WalksView.vue?vue&type=script&lang=js"
export * from "./WalksView.vue?vue&type=script&lang=js"

import "./WalksView.vue?vue&type=style&index=0&id=540dade8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-540dade8"]])

export default __exports__